/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';

import { Image, Col, Row } from 'react-bootstrap';

export interface ILogoProps {
  logoURL?: string;
}

export const Logo = (props: ILogoProps) => {
  if (props?.logoURL) {
    return (
      <Row style={{ textAlign: 'center' }} className="mt-3 mb-2">
        <Col xs={12}>
          <Image src={props?.logoURL} height={60} />
        </Col>
      </Row>
    );
  }
  return null;
};

Logo.defaultProps = {};
